
















































import Vue, { PropType } from 'vue';
import { urlFor } from '@/config/sanity';
import { YearlyEvent } from '@/models/yearlyEvents';

export enum ColorScheme {
  Purple = 'purple',
  Green = 'green',
  Blue = 'blue'
}

export default Vue.extend({
  name: 'SocialEvent',
  props: {
    event: {
      type: Object as PropType<YearlyEvent>,
      required: true,
    },
    colorScheme: {
      type: String,
      default: () => ColorScheme.Purple.toString(),
      validator: (value: string) => [
        ColorScheme.Purple.toString(),
        ColorScheme.Green.toString(),
        ColorScheme.Blue.toString(),
      ].indexOf(value) !== -1,
    },
  },
  methods: {
    urlFor,
  },
});
